pyzel.social = {

	// searchs for share icons
	// and if they have links, open
	// if not share
	init: //$( 

		()=>{

		//function(){	

			//console.log('searching for share icons');

			//console.log( $('main a.icon') );

			$('main a.icon').on('click', ( e )=>{			
			
				e.preventDefault();
				
				let el = $( e.target );
				//let el = $( e.currentTarget );

				//e.preventDefault();

				//console.log( el.data('url') );

				//console.log( el );
				//return false;

				//if( el.prop('href') != '#' ) return 0;

				//console.log( 'href' );
				//console.log( el.prop('href') );

				//if( el.prop('href') != '#' ) console.log('href != #');

				//if( el.data('url') ) return 0;

				let url = '';

				// if no url is defined, is share current page
				// maybe use href?
				// how will be the "follow"?
				if( el.data('url') ){

					//console.log('a');fo

					url = el.data('url');

					//el.prop('href', url );

					//el.trigger('click');

					window.open( url );

					return 0;

				}else{				

					//console.log('b');					

					let network = el.attr('class').split(' ')[1];

					//console.log( network );

					//console.log( el.data('img') );

					url = window.location.href;	

					pyzel.social[network]( encodeURIComponent( url ), el.data('img'), el.data('txt') );				

				}							

			});

		},

	//),
	
	instagram: ( url )=>{

		// share on insta? think not..
		//console.log('insta yo! '+url);

	},	

	googleplus: ( url )=>{

		window.open('https://plus.google.com/share?url='+url);

	},	

	twitter: ( url )=>{
			
		window.open('https://twitter.com/intent/tweet?text=Pyzel+Surfboards:+'+url);

	},	

	facebook: ( url )=>{

		window.open('https://www.facebook.com/sharer/sharer.php?u='+url);

	},

	pinterest: ( url, img, txt )=>{
	
		//console.log( url );
		//console.log( img );

		// martelate while on dev phase..
		url = 'http://www.pyzelsurfboards.com/';

		// this is supposed to have an image..
		// it could be the one from open graph, but wait..
		window.open('http://pinterest.com/pin/create/link/?url='+url+'&media='+img+'&description=Pyzel%20Surfboards%20-%20'+txt);	

	},

	// makes the icons work on riders and about
	build_links: ( networks )=>{

		//console.log('building social links');
		//console.log( networks );

		$.each( networks, ( k, i )=>{

	 		//console.log( i );

	 		// FB
	 		if( i.id_socialnetwork == 1 ){

	 			$('.icons a.icon.facebook').css('display','inline-block').show().data( 'url', i.url );

	 		// twitter
	 		}else if( i.id_socialnetwork == 2 ){

	 			$('.icons a.icon.twitter').css('display','inline-block').data( 'url', i.url );

			// youtubiu	
	 		}else if( i.id_socialnetwork == 3 ){

	 			$('.icons a.icon.youtube').css('display','inline-block').data( 'url', i.url );	 			

	 		// insta	
	 		}else if( i.id_socialnetwork == 4 ){

	 			$('.icons a.icon.instagram').css('display','inline-block').data( 'url', i.url );

	 			//console.log( i.url );

	 			let instagram_url_array = i.url.split('/');

	 			// filter empty
	 			instagram_url_array = instagram_url_array.filter( n => n );

				//console.log( instagram_url_array );

				//console.log( '@'+instagram_url_array[ instagram_url_array.length - 1 ] );

	 			$('#instagram-name').text( '@'+instagram_url_array[ instagram_url_array.length - 1 ] );

			// vimeo	
	 		}else if( i.id_socialnetwork == 5 ){

	 			$('.icons a.icon.vimeo').css('display','inline-block').data( 'url', i.url );	 		

	 		}else{

	 			console.log('pizel.social.build_links(): icon for this network ('+i.socialnetwork+') does not exist on the GUI');

	 		}

	 	})		

	}

}